import React from 'react'
import styled from 'styled-components'
import StyledText from '../../../../components/StyledComponents/StyledText';
import { useTheme } from '../../../../middleware/ThemeContext';
import { font } from '../../../../utils/themes';
import TooltipIcon from '../../../../assets/icons/Tooltip';
import ViewIcon from '../../../../assets/icons/ViewIcon';
import StyledToolTip from '../../../../components/StyledComponents/StyledTooltip';

interface CardIconHeaderProps {
    icon: React.ReactNode;
    title: string;
    count?: string | number;
    iconBgColor?: string;
    iconColor?: string;
    tooltipText?: string;
    viewIcon?: boolean;
    className?: string;
}

const CardIconHeader: React.FC<CardIconHeaderProps> = ({ icon, title, count, iconBgColor, iconColor, tooltipText, viewIcon, className }) => {
    const {theme} = useTheme();
  return (
    <div className={`d-flex gap-3 ${className}`}>
        <IconCircle style={{ backgroundColor: iconBgColor }}>{icon}</IconCircle>
        <div style={{ width: 'calc(100% - 70px)' }}>
            <div className='mb-3 d-flex align-items-center justify-content-between'>
                <StyledText
                    fontSize='16px'
                    fontWeight={600}
                    textColor={theme.CorporateTheme.colors.textSecondary}
                    // className='mb-3'
                >
                    {title}
                </StyledText>
                <div className='d-flex align-items-center gap-3'>
                    {tooltipText &&
                    <StyledToolTip
                        title={tooltipText}
                        placement='bottom'
                    >
                        <TooltipIcon />
                    </StyledToolTip>
                    }
                    {viewIcon &&
                    <ViewIcon />
                    }
                </div>
            </div>
            <StyledText
                fontSize='34px'
                fontWeight={700}
                fontFamily={font.lato}
                textColor={theme.CorporateTheme.colors.textPrimary}
            >
                {count}
            </StyledText>
        </div>
    </div>
  )
}

export default CardIconHeader

export const IconCircle = styled('div')(({ theme }) => ({
    borderRadius: '50%',
    width: '54px',
    height: '54px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));